<mat-toolbar color="accent">Enroling from a File</mat-toolbar>

<mat-dialog-content class="!text-black">
  <div class="flex flex-col gap-4">
    <p>
      You can upload an Excel or CSV file to enrol users into a campaign run.
      The file must contain the following columns for a
      {{ data.campaign.scope }} campaign:
    </p>

    <table mat-table [dataSource]="columns">
      <ng-container matColumnDef="header">
        <th *matHeaderCellDef mat-header-cell class="text-xs">Column</th>
        <td *matCellDef="let column" mat-cell>
          <div class="text-xs font-bold">
            {{ column.header }}
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th *matHeaderCellDef mat-header-cell class="text-xs">Description</th>
        <td *matCellDef="let column" mat-cell>
          <div class="text-xs">
            {{ column.description }}
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="example">
        <th *matHeaderCellDef mat-header-cell class="text-xs">Example</th>
        <td *matCellDef="let column" mat-cell>
          <div class="rounded-md bg-slate-100 px-2 py-1 text-xs text-slate-500">
            {{ column.example }}
          </div>
        </td>
      </ng-container>

      <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
      <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
    </table>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <pt-buttons-container padding="none">
    <button mat-stroked-button mat-dialog-close>Close</button>
  </pt-buttons-container>
</mat-dialog-actions>
